/** Mirrors backend billing-visit-type helpers for UI + print. */

/** Manage Rates modal only — not used for new invoice line items. */
export const CLINICAL_VISIT_TYPES = [
  "SOC",
  "EVALUATION",
  "FOLLOW_UP",
  "REGULAR_DC",
  "OASIS_DC",
  "ROC",
  "REASSESSMENT",
];

export const visitTypeDisplayLabel = (visitType) => {
  const v = String(visitType || "").trim();
  if (!v) return "";
  if (v.toLowerCase() === "hourly") return "HOURLY";
  if (v.toLowerCase() === "fixed") return "FIXED";
  return v.replace(/_/g, " ").toUpperCase();
};

export const BILLING_VISIT_TYPE_OPTIONS = [
  { value: "hourly", label: "HOURLY" },
  { value: "fixed", label: "FIXED" },
];

/** Invoice line-item dropdown: new billing modes + existing clinical types. */
export const INVOICE_VISIT_TYPE_OPTIONS = [
  ...BILLING_VISIT_TYPE_OPTIONS,
  ...CLINICAL_VISIT_TYPES.map((value) => ({
    value,
    label: visitTypeDisplayLabel(value),
  })),
];

export const isHourlyVisitType = (visitType) =>
  String(visitType || "").trim().toLowerCase() === "hourly";

export const isFixedVisitType = (visitType) =>
  String(visitType || "").trim().toLowerCase() === "fixed";

export const isLegacyClinicalVisitType = (visitType) => {
  const v = String(visitType || "").trim();
  if (!v || isHourlyVisitType(v) || isFixedVisitType(v)) return false;
  return true;
};

export const roundMoney = (value) =>
  Math.round((Number(value) || 0) * 100) / 100;

/** Line total: hourly → hours × rate; fixed/legacy → rate. */
export const computeLineItemTotal = (item = {}) => {
  const rate = Number(item.rate) || 0;
  if (isHourlyVisitType(item.visitType)) {
    const hours = Number(item.hours) || 0;
    return roundMoney(hours * rate);
  }
  return roundMoney(rate);
};

export const formatHoursDisplay = (hours) => {
  const n = Number(hours);
  if (!Number.isFinite(n) || n <= 0) return "—";
  return Number.isInteger(n) ? String(n) : n.toFixed(2);
};

/** Prefer API `total`; fall back to client-side calculation. */
export const computeLineItemTotalFromRow = (item = {}) => {
  if (item.total != null && item.total !== "") {
    return roundMoney(item.total);
  }
  return computeLineItemTotal(item);
};

export const computeInvoiceTotal = (items = []) =>
  (items || []).reduce(
    (sum, item) => sum + computeLineItemTotalFromRow(item),
    0,
  );
